import { AfterContentInit, ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { FinancialModel, OtherFinancialModel, PcoModel } from 'src/app/shared/models/abre-cuentas.model';
import { ExternalRequest } from 'src/app/shared/models/channel-communicator/external-request.model';
import { ExternalResponse } from 'src/app/shared/models/channel-communicator/external-response.model';
import { CheckboxModel } from 'src/app/shared/models/common.model';
import { Changes, TagEvent } from 'src/app/shared/models/dali-tags.model';
import { LogDeviceModel } from 'src/app/shared/models/log-device.model';
import { OccupationModel } from 'src/app/shared/models/occupation.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers-onboarding.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { ProductLoaderService } from 'src/app/shared/services/product-loader/product-loader.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { FormatNumberService } from 'src/app/shared/utils/format-number.service';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { BitacoraService } from '../../../shared/services/bitacora/bitacora.service';
import { callbackAdjustContratarTC } from 'src/app/shared/constants/adjust-callback';

@Component({
  selector: 'app-income-form',
  templateUrl: './income-form.component.html',
  styleUrls: ['./income-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class IncomeFormComponent implements OnInit, AfterContentInit {
  peso = { code: 'COP', locale: 'es-co', decimal: 0, display: 'symbol' };
  formGroup: FormGroup;
  financialInfo: FinancialModel;
  checkboxInfoIncomes: CheckboxModel;
  reactiveErrorIncomes: string = null as any;
  activeInput = false;
  configs: { [id: string]: any };
  scanResponse: ExternalResponse;
  getDeviceInfoRq: ExternalRequest;
  devicePrint: any;
  product_type: string;
  ocupationSelected: OccupationModel;
  informationText: string;
  categoryValue: any;
  origins: any;
  incomesSourceSelection: any;
  incomesValue: string;
  smlv: number;
  radioOptions: any = [];
  occupations: any = [];
  productsMultiSelcted: any = [];
  incomeNew = false;
  showForm = true;
  radioOtherIncomes = false;
  reactiveErrorOtherIncomes = '';
  otherIncomesValue: any;
  otherIncomes: any;
  otherFinancialInfo: OtherFinancialModel;
  otherSourceIncome: string;
  has_second_headline: any;
  config = {
    allowNegative: false,
    decimal: ',',
    precision: 0,
    thousands: '.',
    prefix: '$ ',
  };

  constructor(
    public copyService: CopyService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    public abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private navigationService: NavigationService,
    private bioCatchService: BioCatchService,
    private captureService: CaptureService,
    private taggingService: TaggingService,
    private numberHelper: FormatNumberService,
    private bitacoraService: BitacoraService,
    private validationHelperService: ValidationHelperService,
    private productLoaderService: ProductLoaderService,
    private helperService: HelpersService,
    private adjustEvent: AdjustEvent,
  ) {
    this.headerService.show(true, true, true);
    this.devicePrint = new LogDeviceModel();
    this.formGroup = this.formBuilder.group({});
    this.categoryValue = {
      module: 'body',
      type: 'textField',
      position: 'center',
    };
  }
  /**
   * Summary Initial method on active page
   */
  ngOnInit() {
    this.has_second_headline = this.abreCuentasService.getSecondHeadline();
    const productSelected = this.abreCuentasService.getproductSelected();
    this.productsMultiSelcted = this.abreCuentasService.getProductsSelects();
    this.financialInfo = (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline) ?
      this.abreCuentasService.getFinancialInfo() : this.abreCuentasService.getFinancialSecondHeadlineInfo();
    // this.financialInfo.incomes_input = 0;
    let financialInfo = 0;
    if (this.financialInfo !== undefined && this.financialInfo.incomes_input !== undefined) {
      financialInfo = this.financialInfo.incomes;
      this.incomesValue = this.financialInfo.incomes.toString();
    } else {
      this.financialInfo = {
        expenses: 0,
        incomes: 0,
        goods: 0,
        debt: 0,
        funds: undefined as any,
        incomes_input: '0' as any,
        next: false,
      };
    }
    this.product_type = productSelected ? productSelected.product_type : '';
    if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
      const event = {
        eventToken: 'kefp8f',
        callbackParams: callbackAdjustContratarTC,
      };
      this.adjustEvent.adjustTrackEvent(event);
    }
    this.otherIncomes = 0;
    this.otherFinancialInfo = (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline) ?
      this.abreCuentasService.getOtherFinancialInfo() : this.abreCuentasService.getOtherFinancialSecondHeadlineInfo();
    this.radioOptions = [{
      label: 'Sí',
      id: 1,
      name: 'Sí',
      value: 1,
      checked: this.otherFinancialInfo.otherOrigin,
    },
    {
      label: 'No',
      id: 2,
      name: 'No',
      value: 0,
      checked: this.otherFinancialInfo.otherOrigin === undefined ? false : !this.otherFinancialInfo.otherOrigin,
    }];
    this.showForm = this.otherFinancialInfo.otherOrigin === undefined ? true : !this.otherFinancialInfo.otherOrigin;
    if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING ||
      this.product_type === BUSINESS_CONST.MULTI ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN
    ) {
      this.formGroup = new FormGroup({
        incomeValueInput: new FormControl({ value: financialInfo, formState: '' }, [Validators.required, Validators.min(100000), Validators.minLength(6), Validators.max(999999999999)]),
        otherIncomes: new FormControl('', Validators.required),
        otherSourceIncomes: new FormControl(''),
        otherIncomesValue: new FormControl({ value: financialInfo, formState: '' }, [Validators.required, Validators.min(100000), Validators.minLength(6), Validators.max(999999999999)]),
      });
      this.incomeNew = true;
    } else {
      this.formGroup = new FormGroup({
        incomeValueInput: new FormControl({ value: financialInfo, formState: '' },
          [Validators.required, Validators.min(100000), Validators.minLength(5), Validators.max(999999999999)]),
        otherIncomes: new FormControl(''),
        otherSourceIncomes: new FormControl(''),
        otherIncomesValue: new FormControl({ value: financialInfo, formState: '' }, [Validators.required, Validators.min(100000), Validators.minLength(6), Validators.max(999999999999)]),
      });
    }

    this.origins = this.parametersService.getSetting(OpEnum.SOURCE_OF_FUNDS);

    if (this.financialInfo.funds !== undefined) {
      this.incomesSourceSelection = (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline) ?
        this.abreCuentasService.getIncomesOriginSearchSelected() :
        this.abreCuentasService.getIncomesOriginSecondHeadlineSearchSelected();
    } else {
      this.incomesSourceSelection = {
        id: 6,
        value: 'Salario',
      };
    }

    if (this.financialInfo.incomes !== undefined && !this.financialInfo.next) {
      this.financialInfo.incomes_input = this.financialInfo.incomes;
    } else {
      this.financialInfo.incomes_input = '0' as any;
    }
    if (this.financialInfo.incomes_input !== undefined && this.financialInfo.incomes_input !== 0) {
      this.activeInput = true;
    }

    if (!this.financialInfo.next) {
      const occupation = this.abreCuentasService.getOccupationSelected().name;

      this.origins.forEach(origin => {
        origin.default.forEach(occupationDefault => {
          if (occupation !== occupationDefault) { return; }
          this.financialInfo.funds = origin.value;
          this.incomesSourceSelection = {
            id: origin.id,
            value: origin.value,
          };
        });
      });
    } else {
      this.financialInfo.funds = (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline) ?
        this.abreCuentasService.getIncomesOriginSearchSelected().value :
        this.abreCuentasService.getIncomesOriginSecondHeadlineSearchSelected().value;
    }

    this.financialInfo.next = false;
    this.configs = this.abreCuentasService.getAbreCuentasConfigs();

    this.smlv = this.configs['smlv'] || 0;
    this.ocupationSelected = this.abreCuentasService.getOccupationSelected();
    if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE) {
      this.informationText = this.ocupationSelected.incomes_msg || ' ';
    }
  }

  ngAfterContentInit() {
    if (this.financialInfo !== undefined && this.financialInfo.incomes !== undefined) {
      const controlincome = this.formGroup.controls['incomeValueInput'] as FormControl;
      controlincome.setValue(this.financialInfo.incomes);
    }
  }

  /**
   * Summary Set validators to incomes Control
   * @param event
   */
  OnRadioClick(event) {
    const selectOtherSource = this.formGroup.controls['otherSourceIncomes'] as FormControl;
    const inputOtherIncomes = this.formGroup.controls['otherIncomesValue'] as FormControl;
    if (event.value === '1') {
      this.showForm = false;
      this.radioOtherIncomes = true;
      selectOtherSource.setValidators(Validators.required);
      selectOtherSource.enable();
      inputOtherIncomes.setValidators([Validators.required, Validators.min(1), Validators.max(999999999999)]);
      inputOtherIncomes.enable();
      inputOtherIncomes.setValue('');
    } else {
      selectOtherSource.clearValidators();
      selectOtherSource.disable();
      inputOtherIncomes.clearValidators();
      inputOtherIncomes.disable();
      this.radioOtherIncomes = false;
      this.showForm = true;
    }
  }

  /**
   * Summary Set validators to incomes Control
   * @param event
   */
  reactiveInputChangeIncomes() {
    if (!this.activeInput) {
      return;
    }
    try {
      const controlIncomes = this.formGroup.controls['incomeValueInput'] as FormControl;
      this.incomesValue = this.formGroup.controls['incomeValueInput'].value ?
        this.formGroup.controls['incomeValueInput'].value : '';
      if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
        this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
        this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
        this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
        return this.creditCardValidateInput();
      }
      this.reactiveErrorIncomes = controlIncomes.valid ? '' : 'Ingresos mínimos $10.000 COP';
      if (+ this.incomesValue >= 10000 && !isNaN(+ this.incomesValue)) {
        this.reactiveErrorIncomes = undefined as any;
        return;
      }
      if (isNaN(+ this.incomesValue)) {
        this.reactiveErrorIncomes = 'Ingresos mínimos $10.000 COP';
        this.incomesValue = this.incomesValue.substring(0, this.incomesValue.length - 1);
        if (+ this.incomesValue >= 10000) {
          this.reactiveErrorIncomes = undefined as any;
        }
        return;
      }
      /* istanbul ignore else */
      if (+ this.incomesValue < 10000) {
        this.reactiveErrorIncomes = 'Ingresos mínimos $10.000 COP';
        return;
      }
    } catch (error) {
      console.log(error);
    }

  }

  reactiveInputChangeOtherIncomes() {
    const minValue = 0;
    // const controlIncomes = this.formGroup.controls['otherIncomesValue'] as FormControl;
    // const valor: string = controlIncomes.value || '';

    const controlIncomes = this.formGroup.controls['otherIncomesValue'] as FormControl;
    this.otherIncomes = this.formGroup.controls['otherIncomesValue'].value ?
      this.formGroup.controls['otherIncomesValue'].value : '';
    // this.otherIncomes = valor;
    if (+ this.otherIncomes >= minValue) {
      this.reactiveErrorIncomes = '';
    } else {
      this.reactiveErrorIncomes = this.copyService.copies.income_form.errorIncomesValue;
      controlIncomes.setErrors({
        minValue: true,
      });
    }
    return;
  }

  /**
   * Summary validation of min value incomes by ocupation
   */
  creditCardValidateInput() {
    let minValue;
    if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
      minValue = this.has_second_headline ? 1500000 : 2000000;
    } else {
      minValue = (this.ocupationSelected.minimun_inflicted_incomes || 0) * this.smlv;
    }
    const controlIncomes = this.formGroup.controls['incomeValueInput'] as FormControl;
    const valor: string = controlIncomes.value || '';
    // valor = valor.replace('$ ', '').split(/\./).join('');
    if (+ valor >= minValue) {
      this.reactiveErrorIncomes = '';
    } else {
      this.reactiveErrorIncomes = 'Verifica el valor que estás ingresando';
      if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
        const category = {
          module: 'body',
          type: 'warning',
          position: 'center',
        };
        this.pageTagEvent('4', category, 'show', this.navigationService.camelize(this.reactiveErrorIncomes));
      }
      controlIncomes.setErrors({
        minValue: true,
      });
    }
    return;
  }

  /**
   *  Summary Handless the onFocus event
   */
  reactiveOnFocus() {
    this.activeInput = true;
  }

  receiveExtAppResponse = (response: ExternalResponse) => {
    this.scanResponse = response;
    return;
  }

  receiveExtAppResponseDeviceInfo = (response: ExternalResponse) => {
    this.devicePrint = response.data;
    return;
  }

  /**
   * Método para selección de la opción
   *
   * *Method to select an option*
   */
  selectOption(event) {
    this.incomesSourceSelection = event.value;
    this.financialInfo.funds = this.incomesSourceSelection.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    this.financialInfo.incomes_input = + this.incomesValue;
    this.financialInfo.next = true;
    (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline) ?
      this.abreCuentasService.setIncomesOriginSearchSelected(this.incomesSourceSelection) :
      this.abreCuentasService.setIncomesOriginSecondHeadlineSearchSelected(this.incomesSourceSelection);
    (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline) ?
      this.abreCuentasService.setFinancialInfo(this.financialInfo) :
      this.abreCuentasService.setFinancialSecondHeadlineInfo(this.financialInfo);
  }

  /**
   * Método para selección de origen de origen de otros ingresos
   *
   * *Method to select other source incomes*
   */
  selectOtherOption() {
    const controlIncomes = this.formGroup.controls['otherSourceIncomes'] as FormControl;
    const valor: string = controlIncomes.value.value;
    this.otherSourceIncome = valor;
  }

  /**
   * Método para ir a la siguiente pantalla
   *
   * *Method to continue to the next screen*
   */
  next() {
    this.sendTagging('next', 'bottom', '1');
    this.financialInfo = {
      incomes: + this.incomesValue,
      expenses: this.financialInfo.expenses,
      debt: this.financialInfo.debt,
      goods: this.financialInfo.goods,
      funds: this.financialInfo.funds,
      incomes_input: + this.incomesValue,
      next: false,
    };

    const productsMulti = this.productsMultiSelcted.filter(product => product.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE || product.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING || product.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC);

    if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN ||
      productsMulti.length > 0) {
      this.otherFinancialInfo = {
        otherIncomes: this.otherIncomes ? + this.otherIncomes : 0,
        otherFunds: this.otherSourceIncome ? this.otherSourceIncome : '',
        otherOrigin: this.radioOtherIncomes,
      };
      (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline) ?
        this.abreCuentasService.setOtherFinancialInfo(this.otherFinancialInfo) :
        this.abreCuentasService.setOtherFinancialSecondHeadlineInfo(this.otherFinancialInfo);
    }

    (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline) ?
      this.abreCuentasService.setFinancialInfo(this.financialInfo) :
      this.abreCuentasService.setFinancialSecondHeadlineInfo(this.financialInfo);

    if (this.abreCuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
      (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline) ?
        this.navigationService.nextStep('200') :
        this.navigationService.nextStep('201');
      return;
    }

    if (this.validationHelperService.isPassiveProduct() && this.abreCuentasService.getinfoInferredIncomes().codigo !== undefined) {
      if (((this.abreCuentasService.getinfoInferredIncomes().codigo === '422-06'
        || this.abreCuentasService.getinfoInferredIncomes().codigo === '422-07') ||
        (this.abreCuentasService.getinfoInferredIncomes().income_amount !== undefined &&
          this.abreCuentasService.getinfoInferredIncomes().income_amount.amount === 0)) &&
        (this.abreCuentasService.getOccupationSelected().id === 3 || this.abreCuentasService.getOccupationSelected().id === 4)
      ) {
        if (this.incomesValue > this.abreCuentasService.getAbreCuentasConfigs()['min_incomes']) {
          this.abreCuentasService.caseInfoError('106');
          this.navigationService.navigateToGeneralInformation('106');
        } else {
          this.navigationService.nextStep('200');
        }
      }

    } else if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE || productsMulti.length > 0 ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
      this.getPcoAmount();
    } else {
      this.navigationService.nextStep('200');
    }
  }

  /**
   * Método para ir a la siguiente pantalla y guardar la información en bitacora
   *
   * *Method to continue to the next screen and saves info in bitacora*
   */
  resumeApp() {
    // tslint:disable-next-line: no-debugger
    this.next();
    const bitacoraEvent = 'source_incomes';
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
  }

  sendTagging(value: any, position?: string, event?: string, extras?: any) {
    const page = '29';
    this.taggingService.sendTaggValues(value, page, position, event, extras);
  }

  async getPcoAmount() {
    console.log(this.parametersService.getSetting(OpEnum.LIST_TYPE_CONTRACT_LOAN));
    this.productLoaderService.show(this.copyService.copies.show_load_pco,
      this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['PCO']);
    this.bitacoraService.saveDataInBitacora('Ini_loading_PCO');
    await this.captureService.performPco().then(async (res: any) => {
      console.log('res', res);

      if (res !== '200') {
        this.navigationService.navigateToGeneralInformation('107');
        return;
      }
      await this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['PCO']);
      await this.captureService.getChannelComunicator(false, true).then(async (res2: any) => {
        console.log('respuesta dos', res2);
        if (res2 === '107' || res2 === '121' || res2 === '130' || res2 === '129' || res2 === '124' || res2 === '127' || res2 === '17') {
          if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC && res2 === '121') {
            const event = {
              eventToken: 'huswfn',
              callbackParams: callbackAdjustContratarTC,
            };
            this.adjustEvent.adjustTrackEvent(event);
          } else if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN && res2 === '17') {
            this.navigationService.navigateToGeneralInformation('LIBERROR');
            this.bitacoraService.saveDataInBitacora('Normalization_yes');
            return;
          }
          this.navigationService.navigateToGeneralInformation(res2);
        } else if (this.product_type === BUSINESS_CONST.MULTI || this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
          this.pageZoneGray(res2);
        } else {
          this.navigationService.nextStep(res2);
        }
        this.bitacoraService.saveDataInBitacora('Out_loading_PCO');
        this.productLoaderService.hide();
      }).catch(() => this.navigationService.navigateToGeneralInformation('107'));
    }).catch(error => {
      console.log('error', error);
      this.navigationService.navigateToGeneralInformation('107');
    });
  }

  pageZoneGray(res2: string) {
    if (this.abreCuentasService.getProductsSelects() && this.abreCuentasService.getProductsSelects().length > 1) {
      switch (res2) {
        case '202':
          res2 = '202';
          break;
        case '201':
          res2 = '201';
          break;
        case '200':
          res2 = '200';
          break;
        default:
          res2 = '';
          break;
      }
    }
    this.navigationService.nextStep(res2);
  }

  /**
   * @author cramos
   * @param eventNumber id number of event 1/2/3/4
   * @param category object with properties see eventCategories variable
   * @param customAction action of event click/show
   * @param errorName error name track
   */
  pageTagEvent(eventNumber: string, category: any, customAction: string, errorName?: string, formEvent?: any) {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    try {
      const changes: Changes[] = [
        {
          path: EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionName`].path,
          value: EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionName`].value,
        },
        {
          path:
            EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionDetailsProductcategory`].path,
          value:
            EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionDetailsProductcategory`].value,
        },
      ];
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module[category.module],
          type: EVENT.customCategory.type[category.type],
          position: EVENT.customCategory.position[category.position],
        },
        action: EVENT.customAction[customAction],
        label: 'Error',
      };
      switch (eventNumber) {
        case '3':
          event.value = +formEvent.target.value.slice(2).replace(/\./g, '');
          event.label = EVENT[`${tagPageName}E${eventNumber}customLabel`];
          break;
        case '4':
          event.label = `${this.ocupationSelected.name}`;
          break;
      }
      if (errorName) {
        event.errorName = errorName;
      }

      this.taggingService.pageTagEvent(event, changes);
    } catch (error) {
      console.log(error);
    }
  }
}
